import React, { useEffect } from "react";

import style from "../Components/style";

const NurseryClassUse = ({ classList, onClassSelected, isClassView = false }) => {
    useEffect(() => {
        return () => {};
    }, [classList]);
    if (!classList) {
        return (
            <div className="w-100">
                <div className="row">
                    <div
                        className="col"
                        style={{
                            height: "220px",
                            textAlign: "center",
                            paddingTop: `50px`,
                        }}
                    >
                        <span className="dashboard-spinner spinner-xl"></span>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="w-100 tomonote-nursery-class-use">
                <table className="table table-sm table-bordered text-center">
                    <thead>
                        <tr className="" style={{ backgroundColor: style.tableBranchClassUse.header }}>
                            <th scope="col">반명</th>
                            <th scope="col">가입일</th>
                            <th scope="col">최종 접속일</th>
                            <th scope="col">앱 버전</th>
                        </tr>
                    </thead>
                    <tbody>
                        {classList.map((c, idx) => {
                            return isClassView ? (
                                <tr className="is-class-view" key={`class-account-${idx}`}>
                                    <td style={{ backgroundColor: style.tableBranchClassUse.columnFirst }}>{c.className}</td>
                                    <td>{c.createDate ? c.createDate : "-"}</td>
                                    <td>{c.lastAccess ? c.lastAccess : "-"}</td>
                                    <td>{c.version ? c.version : "-"}</td>
                                </tr>
                            ) : (
                                <tr key={`class-account-${idx}`} onClick={isClassView ? null : () => (onClassSelected ? onClassSelected(c.sid) : "")}>
                                    <td style={{ backgroundColor: style.tableBranchClassUse.columnFirst }}>{c.className}</td>
                                    <td>{c.createDate ? c.createDate : "-"}</td>
                                    <td>{c.lastAccess ? c.lastAccess : "-"}</td>
                                    <td>{c.version ? c.version : "-"}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
};

export default NurseryClassUse;
